import React from "react";

import { InnerContainer as UIInnerContainer } from "@jti/ui/eva-components/Header/components/SecondaryNavigation/components/InnerContainer/InnerContainer";

type UIInnerContainerProps = {
  children: React.ReactNode;
};

export function InnerContainer({ children }: UIInnerContainerProps) {
  return <UIInnerContainer>{children}</UIInnerContainer>;
}
